module.exports = __webpack_public_path__ + "img/08.95584c52.jpg";